import {useFormikContext} from 'formik'
import {useEffect, useState} from 'react'
import {InlineTable} from 'src/feature/bite/component'
import ReactQuill from 'react-quill'
import axios from 'axios'
import useRequestParams from 'src/feature/bite/hook/request'
import {Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'
import Toolbar, {formats, modules, QuillToolbar2, modules_2} from 'src/app/context/QuillConfig'
import CropAspect from 'src/feature/bite/hook/useCropAspect'
import {Crop} from 'react-image-crop'

export default function ServiceDetails({
  loading,
  intl,
  editable,
  setEditable,
}: {
  loading: boolean
  intl: any
  editable: any
  setEditable: any
}) {
  const {
    handleSubmit,
    setFieldValue,
    resetForm,
    values,
    initialValues,
    errors: formikErrors,
  } = useFormikContext() as any

  const [tempImage, setTempImage] = useState('')
  const [crop, setCrop] = useState<Crop>()
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null)

  const [resizeImageModal, setResizeImageModal] = useState(false)
  const {auth} = useRequestParams()
  const [, setAboutUsSection] = useState<any>({
    name: 'Additional Information',
    content: '',
  })

  const [errors, setErrors] = useState({
    additionalInformations: '',
    infoContentData: '',
  })

  useEffect(() => {
    const aboutUsSection = initialValues?.infoContentData?.find(
      (section: any) => section.name === 'Additional Information'
    )

    if (aboutUsSection) {
      const dataUrl = aboutUsSection?.contentURL

      if (dataUrl) {
        const data = axios.get(dataUrl, {
          headers: {
            Authorization: `Bearer ${auth()?.token}`,
          },
        })

        setAboutUsSection({
          ...aboutUsSection,
          content: data,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const column = [
    [
      {
        title: 'Online Class',
        key: 'onlineClass',
        dataIndex: 'onlineClass',
        yesOrNo: true,
        editable: true,
        tooltip: 'Select if you offer online sessions.',
        edit: 'select',
        selects: [
          {value: 1, text: 'Yes'},
          {value: 2, text: 'No'},
        ],
      },
      {
        title: 'Monday',
        key: 'workingHourList',
        dataIndex: 1,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
      {
        title: 'Wednesday',
        key: 'workingHourList',
        dataIndex: 3,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
      {
        title: 'Friday',
        key: 'workingHourList',
        dataIndex: 5,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
      {
        title: 'Sunday',
        key: 'workingHourList',
        dataIndex: 0,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
    ],
    [
      {
        title: 'Group Class',
        key: 'groupClass',
        dataIndex: 'groupClass',
        yesOrNo: true,
        editable: true,
        tooltip: 'Select if you provide group sessions.',
        edit: 'select',
        selects: [
          {value: 1, text: 'Yes'},
          {value: 2, text: 'No'},
        ],
      },
      {
        title: 'Tuesday',
        key: 'workingHourList',
        dataIndex: 2,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
      {
        title: 'Thursday',
        key: 'workingHourList',
        dataIndex: 4,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
      {
        title: 'Saturday',
        key: 'workingHourList',
        dataIndex: 6,
        editable: true,
        edit: 'time-working-hours',
        tooltip: 'Specify your available hours for this day if you offer services.',
      },
    ],
  ]

  const handleQuillChange = (
    value: string,
    fieldName: string,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const charLimit = 1001
    const htmlEl = document.createElement('div')
    htmlEl.innerHTML = value
    const textValue = htmlEl.innerText.trim()
    console.log('fieldName', fieldName)
    if (textValue.length > charLimit) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName === 'infoContentData.0.data' ? 'infoContentData' : fieldName]:
          intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 1000}),
      }))
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName === 'infoContentData.0.data' ? 'infoContentData' : fieldName]: '',
      }))
      setFieldValue(fieldName, value)
    }
  }

  const handleImageDelete = (index: number) => {
    const filteredImages = values.imagesData?.filter((image: any, i: number) => i !== index)
    setFieldValue('imagesData', filteredImages)
  }

  const handleImageUpload = (index: number) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.png, .jpg, .jpeg'
    input.onchange = (e: any) => {
      if (e.target.files && e.target.files.length > 0) {
        setCrop(undefined)
        const reader = new FileReader()
        reader.addEventListener('load', () => {
          setTempImage(reader.result?.toString() || '')
          setResizeImageModal(true)
          setSelectedImageIndex(index)
        })
        reader.readAsDataURL(e.target.files[0])
      }
    }
    input.click()
  }

  const handleSaveImage = (newImage: any) => {
    const updatedImages = [...(values.imagesData || [])]
    updatedImages[selectedImageIndex!] = newImage
    setFieldValue('imagesData', updatedImages)
    setTempImage('')
    setResizeImageModal(false)
  }

  return (
    <>
      <Modal
        show={resizeImageModal}
        onHide={() => setResizeImageModal(false)}
        size='lg'
        centered
        backdrop='static'
      >
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {tempImage && (
            <CropAspect
              selectedImageIndex={selectedImageIndex}
              values={values}
              crop={crop}
              setCrop={setCrop}
              imgSrc={tempImage}
              setImgSrc={setTempImage}
              setResizeImageModal={setResizeImageModal}
              setFieldValue={setFieldValue}
              onSave={handleSaveImage}
            />
          )}
        </Modal.Body>
      </Modal>

      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0 d-flex justify-content-between w-100'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>
                {intl.formatMessage({id: 'PROVIDER.AVAILABILITY_SERVICES'})}
              </h3>
              <p className='text-muted fw-normal fs-6'>
                Use this section to outline your services and present your professional profile.
                Details provided here—other than your service availability—will appear on your Vasco
                Life App profile.
              </p>
            </div>
          </div>
        </div>
        <div className='card-body p-9'>
          <div className='row'>
            <div className='mb-5 '>
              <div>
                <h3 className='fs-4 fw-bold required'>
                  About
                  <span className='position-relative'>
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip>
                          Write a short description of your services and what customers can expect.
                        </Tooltip>
                      }
                    >
                      <i className='bi bi-info-circle text-primary ms-1'></i>
                    </OverlayTrigger>
                  </span>
                </h3>
              </div>
              {editable.serviceDetails && (
                <div>
                  <div className='row py-5'>
                    <div className='col-10'>
                      <Toolbar />
                      <ReactQuill
                        placeholder={intl.formatMessage({id: 'DESCRIPTION'})}
                        formats={formats}
                        modules={modules}
                        value={values.additionalInformations}
                        onChange={(value) =>
                          handleQuillChange(value, 'additionalInformations', setFieldValue)
                        }
                      />

                      {formikErrors.additionalInformations && (
                        <div className='text-danger mt-3'>
                          {typeof formikErrors.additionalInformations === 'string' &&
                            formikErrors.additionalInformations}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {!editable.serviceDetails && (
                <div className='row'>
                  <div className='col-10'>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: values.additionalInformations || '',
                      }}
                    ></div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='row mb-7 align-items-center'>
                <h3 className='fs-4 fw-bold mb-5'>Additional Information</h3>
                <div className='col-lg-10'>
                  {editable.serviceDetails ? (
                    <>
                      <QuillToolbar2 />
                      <ReactQuill
                        formats={formats}
                        modules={modules_2}
                        id='about-us'
                        placeholder={intl.formatMessage({id: 'DESCRIPTION'})}
                        value={values.infoContentData?.[0]?.data}
                        onChange={(value) =>
                          handleQuillChange(value, `infoContentData.${0}.data`, setFieldValue)
                        }
                      />
                      {errors.infoContentData && (
                        <div className='text-danger mt-3'>
                          {typeof errors.infoContentData === 'string' && errors.infoContentData}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className='row'>
                      <div className='col-10'>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: values.infoContentData?.[0]?.data || '',
                          }}
                        ></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <InlineTable
            loading={loading}
            dataSource={initialValues}
            columns={column}
            editable={editable.serviceDetails}
            values={values}
          />

          {!editable.serviceDetails && (
            <div className='row'>
              <div className='mb-5'>
                <div>
                  <h3 className='fs-4 fw-bold required'>Image</h3>
                </div>

                <div className='d-flex gap-3'>
                  {[0, 1, 2].map((index) => (
                    <div
                      key={index}
                      className='image-input image-input-outline border border-dashed bg-light d-flex align-items-center'
                      style={{
                        maxWidth: '150px',
                        maxHeight: '150px',
                        minWidth: '150px',
                        minHeight: '150px',
                        position: 'relative',
                      }}
                    >
                      {values.imagesData?.[index]?.imageFullUrl ? (
                        <img
                          src={
                            values.imagesData[index].imageFullUrl.includes('http')
                              ? values.imagesData[index].imageFullUrl
                              : `${process.env.REACT_APP_IMG_DOMAIN}${values.imagesData[index].imageUrl}`
                          }
                          alt=''
                          className='rounded'
                          style={{
                            objectFit: 'contain',
                            width: '100%',
                            height: '100%',
                            maxHeight: '150px',
                          }}
                        />
                      ) : (
                        <div
                          className='d-flex align-items-center justify-content-center'
                          style={{
                            width: '100%',
                            height: '100%',
                          }}
                        >
                          <i className='bi bi-image fs-4x'></i>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {editable.serviceDetails && (
            <div className='d-flex'>
              <div className='row'>
                <h2 className='required'>Image</h2>
                <div className='fs-7 w-50 text-danger'>
                  {intl.formatMessage({id: 'GLOBAL.UPLOAD.THUMBNAIL'})}
                </div>

                <div className='d-flex gap-3 align-items-center py-5'>
                  {[0, 1, 2].map((index) => (
                    <div
                      key={index}
                      className='image-input image-input-outline border border-dashed bg-light d-flex align-items-center'
                      style={{
                        maxWidth: '150px',
                        maxHeight: '150px',
                        minWidth: '150px',
                        minHeight: '150px',
                        position: 'relative',
                      }}
                    >
                      {values.imagesData?.[index]?.imageFullUrl ? (
                        <img
                          src={
                            values.imagesData[index].imageFullUrl.includes('http')
                              ? values.imagesData[index].imageFullUrl
                              : `${process.env.REACT_APP_IMG_DOMAIN}${values.imagesData[index].imageUrl}`
                          }
                          alt=''
                          className='rounded'
                          style={{
                            objectFit: 'contain',
                            width: '100%',
                            height: '100%',
                            maxHeight: '150px',
                          }}
                        />
                      ) : (
                        <div
                          className='d-flex align-items-center justify-content-center'
                          style={{
                            width: '100%',
                            height: '100%',
                          }}
                        >
                          <i className='bi bi-image fs-4x'></i>
                        </div>
                      )}
                      <button
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                        type='button'
                        style={{
                          position: 'absolute',
                          top: '5px',
                          right: '5px',
                        }}
                        onClick={() => handleImageUpload(index)}
                      >
                        <i className='ki-outline ki-pencil fs-7'></i>
                      </button>
                      {values.imagesData?.[index]?.imageFullUrl && (
                        <button
                          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                          type='button'
                          style={{
                            position: 'absolute',
                            top: '5px',
                            right: '35px',
                          }}
                          onClick={() => handleImageDelete(index)}
                        >
                          <i className='ki-outline ki-cross fs-7'></i>
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                {formikErrors?.imagesData && (
                  <div className='text-danger'>
                    {typeof formikErrors?.imagesData === 'string' && formikErrors?.imagesData}
                  </div>
                )}
              </div>
            </div>
          )}

          <div className='text-muted fs-7 w-100 mt-5'>
            Please upload your profile image. Only *.png, *.jpg and *.jpeg image files are accepted.
          </div>
        </div>

        <div className='card-footer d-flex w-100 justify-content-end'>
          {editable.serviceDetails ? (
            <div>
              <button
                className='btn btn-primary'
                style={{marginRight: 10}}
                onClick={() => {
                  setEditable({
                    overview: false,
                    professionalDetails: false,
                    serviceDetails: false,
                    socialMedia: false,
                    contractDetails: false,
                    financialDetails: false,
                  })
                  resetForm()
                }}
              >
                <i className='bi bi-x me-2'></i>
                {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
              </button>
              <button
                className='btn btn-primary'
                disabled={loading}
                type='button'
                onClick={async () => {
                  values.type = 2
                  await handleSubmit()
                }}
              >
                <i className='bi bi-save2 me-2'></i>
                {loading
                  ? intl.formatMessage({id: 'GLOBAL.BUTTON.SAVING'})
                  : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
              </button>
            </div>
          ) : (
            <button
              className='btn btn-primary'
              onClick={() => {
                resetForm()
                setEditable({
                  overview: false,
                  professionalDetails: false,
                  serviceDetails: true,
                  socialMedia: false,
                  contractDetails: false,
                  financialDetails: false,
                })
              }}
            >
              <i className='bi bi-pencil me-2'></i>
              {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
            </button>
          )}
        </div>
      </div>
    </>
  )
}
